import classNames from "classnames";

// Builds a compact page list with ellipsis, e.g. [1, '…', 4, 5, 6, '…', 10]
const buildPageList = (page, totalPages) => {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }
  const pages = new Set([1, totalPages, page, page - 1, page + 1]);
  const sorted = [...pages].filter((p) => p >= 1 && p <= totalPages).sort((a, b) => a - b);

  const withGaps = [];
  sorted.forEach((p, i) => {
    if (i > 0 && p - sorted[i - 1] > 1) withGaps.push("…");
    withGaps.push(p);
  });
  return withGaps;
};

/** Matches Figma "Pagination / Type=Page default, Shape=Square" component. */
const Pagination = ({ page, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  return (
    <nav className="ea-pagination" aria-label="Table pagination">
      <button
        type="button"
        className="ea-pagination__nav"
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
      >
        <i className="material-icons">chevron_left</i>
        Previous
      </button>

      <div className="ea-pagination__numbers">
        {buildPageList(page, totalPages).map((p, i) =>
          p === "…" ? (
            <span key={`ellipsis-${i}`} className="ea-pagination__ellipsis">…</span>
          ) : (
            <button
              key={p}
              type="button"
              className={classNames("ea-pagination__number", { "ea-pagination__number--active": p === page })}
              onClick={() => onPageChange(p)}
            >
              {p}
            </button>
          )
        )}
      </div>

      <button
        type="button"
        className="ea-pagination__nav"
        disabled={page >= totalPages}
        onClick={() => onPageChange(page + 1)}
      >
        Next
        <i className="material-icons">chevron_right</i>
      </button>
    </nav>
  );
};

export default Pagination;
